module.exports = __webpack_public_path__ + "img/pageinteriors_profesionales-independientes-y-pymes-04dano.3b290223.jpg";